<template>
<div id="DepriciationCreate" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader" v-if="$route.params.id > 0">Update Depreciation Schedule</span>
                <span class="page-title" id="purchaseorderHeader" v-else>Add Depreciation Schedule</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backToList">
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content dep-schedule-crud">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="DepriciationForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="vehicle_id">Asset:</label>
                                    <v-select v-model="vehicle_id" name="vehicle_id"
                                        label="text" :filterable="false" :options="vehicleArr"
                                        @search="onSearchVehicle"
                                        placeholder="Select Asset" class="custom-ci-auto-search">
                                        <template slot="no-options">
                                            Search Asset...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ vehicle_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="year">Unit Year</label>
                                    <input :disabled="true" type="text" v-model="year" id="year" name="year" placeholder="Year" class="form-control">
                                </div>

                                <div class="col form-group">
                                    <label class="control-label" for="year">Make</label>
                                    <input :disabled="true" type="text" v-model="make" id="make" name="make" placeholder="Make" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="year">Model</label>
                                    <input :disabled="true" type="text" v-model="model" id="model" name="model" placeholder="Model" class="form-control">
                                </div>
                                <div class="col-sm-6">
                                    <label class="control-label" for="type">Customer</label>
                                    <input type="text" :disabled="true" v-model="customer" id="customer" name="customer" placeholder="Customer" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="schedule_type">Schedule Type:</label>
                                    <v-select v-model="schedule_type" name="schedule_type" placeholder="Select Schedule Type."
                                            label="text"
                                            :options="scheduleTypeArr">
                                    </v-select>
                                    <div class="field-error">{{schedule_type_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="method">Method</label>
                                        <input :disabled="true" type="text" v-model="method" id="method" name="method" placeholder="Method" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="method">Residual %</label>
                                    <input type="text" v-model="residual" id="residual" name="residual" placeholder="Residual" class="form-control" @keypress="isAmountCheck($event)">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="method">Initial Residual</label>
                                    <!-- <label class="control-label" for="method">{{initial_residual}}</label> -->
                                    <input type="text" v-model="initial_residual" id="initial_residual" name="initial_residual" v-on:blur="calculateDeprate(); initial_residual = leaveFocus($event);" class="form-control" @keypress="isAmountCheck($event)"
                                    @focus="initial_residual = enterVal($event)">
                                    <div class="field-error">{{residual_error_msg}}</div>
                                </div>

                                <div class="col form-group">
                                    <label class="control-label require" for="method">Capital Amount</label>
                                    <input type="text" v-model="amount" :disabled="isExistCap" id="amount" name="amount" placeholder="amount" class="form-control" v-on:blur="calculateDeprate();amount = leaveFocus($event)" @keypress="isAmountCheck($event)">
                                    <div class="field-error">{{amount_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="method">Depreciation Rate</label>
                                    <input type="text" v-model="rate" :disabled="true" id="rate" name="rate" placeholder="rate" class="form-control" @keypress="isAmountCheck($event)">
                                    <div class="field-error">{{rate_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="method">Depreciation Amount</label>
                                    <input type="text" v-model="dep_amount" :disabled="true" id="dep_amount" name="dep_amount" placeholder="amount" class="form-control" @keypress="isAmountCheck($event)">
                                    <!-- <div class="field-error">{{rate_error_msg}}</div> -->
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="start_date">Start Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="start_date" name="start_date" v-model="start_date" :config="optionsDate"></date-picker>
                                        <label for="start_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ start_date_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="method">Duration</label>
                                    <input type="text" v-model="duration" id="duration" name="duration" placeholder="Duration (Months)" v-on:blur="calculateDeprate()" class="form-control">
                                    <div class="field-error">{{ duration_error_msg }}</div>
                                </div>
                                <!-- <div class="col form-group">
                                    <label class="control-label" for="method">No. of Payment</label>
                                    <input :disabled="true" type="text" v-model="payment_no" id="payment_no" name="payment_no" class="form-control">
                                </div> -->
                                <div class="col form-group">
                                    <label class="control-label" for="method">Last Date</label>
                                    <input :disabled="true" type="text" v-model="last_date" id="last_date" name="last_date" class="form-control">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" v-if="$route.params.id > 0" id="CreateDepriciationBtn" class="btn btn-primary" v-on:click.prevent="CreateDepriciation">
                                    <i class="fp-reload"> </i> Update
                                </button>
                                <button type="submit" v-else id="CreateDepriciationBtn" class="btn btn-primary" v-on:click.prevent="CreateDepriciation">
                                    <i class="fp-save"> </i> Save
                                </button>
                                <button type="submit" v-if="$route.params.id == undefined" id="CreateAndContinueDepriciationBtn" class="btn btn-tertiary" v-on:click.prevent="CreateDepriciation(flag='Save and Continue')">
                                    <i class="fp-save-continue"> </i> Save and Continue
                                </button>
                                <button type="submit" id="CancelDepriciationBtn" class="btn btn-tertiary" v-on:click.prevent="backToList">
                                    <i class="fp-close"> </i> Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';


export default {
    name: "DepriciationCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Depreciation | " +process.env.COPYRIGHT_NAME : "Create Depreciation | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins: [commonMixins, contractMixins],
    data: () => ({
        isEdit: false,
        permissions: [],
        cantAccessPage: "",
        vehicle_id: "",
        vehicleArr:[],
        scheduleTypeArr:[],
        vehicle_error_msg:'',
        year:'',
        make:'',
        model:'',
        schedule_type:'',
        schedule_type_error_msg:'',
        customer:'',
        method:'',
        residual:'',
        initial_residual:'',
        amount:'',
        rate:'',
        start_date:'',
        start_date_error_msg:'',
        duration:'',
        payment_no:'',
        frequency:'',
        last_date:'',
        loading: false,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        duration_error_msg :"",
        rate_error_msg :'',
        amount_error_msg :'',
        dateArr:[],
        residual_error_msg:'',
        dep_amount:'',
        isExistCap:false
    }),

    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_depreciation_schedule') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        vehicle_id: function(val) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.customer = '';
            if(!segments[3]){
              self.year = '';
              self.make = '';
              self.model = '';
              self.amount = '';
              self.initial_residual = '';
            }
            if(val != null && val != '' && val.value){

                $.ajax({
                    url: process.env.ROOT_API + "/asset/"+val.value,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",

                    success: function (data) {
                        //if data is edit than dont make model id blank
                        if ( data.status == "success" ) {

                            if (data.content.vmodelsCode != null && data.content.vmodelsCode != '') {
                                self.make = data.content.vmCode+' | '+data.content.vmName;
                            } else {
                                self.make = "";
                            }

                            if (data.content.vmodelsCode != null && data.content.vmodelsCode != '' ) {
                                self.model = data.content.vmodelsCode+' | '+data.content.vmodelsName;
                            }
                            if (data.content.year != null ) {
                                self.year = data.content.year;
                            }
                            //capital amount for asset from backend
                            if(!segments[3]){
                                if (data.content.original_cost != undefined && data.content.original_cost != null && data.content.original_cost != '') {
                                    self.amount = data.content.original_cost;
                                }else{
                                    self.amount = data.content.purchase_price;
                                }
                                self.calculateDeprate();
                                //removed disabling the capitalCost if amount already there or not
                                // if (self.amount != '' && self.amount > 0){
                                //     self.isExistCap = true;
                                // }else{
                                //     self.isExistCap = false;
                                // }
                                if(data.content.contract_asset_residual != undefined && data.content.contract_asset_residual != null && data.content.contract_asset_residual != ''){
                                  self.initial_residual = data.content.contract_asset_residual;
                                }else{
                                  self.initial_residual = "";
                                }

                            }

                            if (data.content.custCode != null && data.content.custCode != '' ) {
                                self.customer = data.content.custCode+" | "+data.content.custName;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-data')
                    }
                });
            }

        },
        duration:function(val){
            var self = this;

            if (val != null && val != '' && self.start_date != ''){
                // var dt = new Date(self.start_date);
                var days = moment(self.start_date).format('DD');

                if (days <= 14){
                    val -= 1;
                }else{

                }
                self.last_date = moment(self.start_date).add(val, 'months').format('MM/DD/YYYY');
                // self.last_date = self.addMonths(dt,val);
                self.last_date = moment(self.last_date).endOf('month').format('MM/DD/YYYY');
                // self.getLastDateofmonth();
            }
        },
        start_date:function(val){
            var self = this;

            if (val != null && val != '' && self.duration != '' && self.duration > 0){
                // var dt = new Date(self.start_date);
                var days = moment(self.start_date).format('DD');
                var dur = self.duration;
                if (days <= 14){
                    dur -= 1;
                }else{

                }
                self.last_date = moment(self.start_date).add(dur, 'months').format('MM/DD/YYYY');
                // self.last_date = self.addMonths(dt,val);
                self.last_date = moment(self.last_date).endOf('month').format('MM/DD/YYYY');
                // self.getLastDateofmonth();
            }
        },
        schedule_type: function(val){
            if (val.method != undefined){
                this.method = val.method;
            }
        }
    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;

            // }
            var dateFormat = userObj["date_format"];

            if ( segments[3]){
                self.loadDepriciation();
            }
        }

        self.getPermissions();
        this.loadFieldData(['depriciation_type']);
        var path = window.location.pathname;
        var segments = path.split("/");

    },
    methods: {
        onSearchVehicle(search, loading) {
            var self = this;
            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'owned vehicle', '');
            }

        },

        CreateDepriciation(flag) {
            var self = this;
            var error = false;
            self.vehicle_error_msg = "";
            self.schedule_type_error_msg = "";
            self.start_date_error_msg = "";
            self.duration_error_msg = "";
            self.rate_error_msg = '';
            self.amount_error_msg = '';
            self.residual_error_msg = '';

            if (self.vehicle_id.pool != undefined && self.vehicle_id.pool == 'INV'){
                self.vehicle_error_msg = "Asset is in inventory pool.";
                error = true;
            }

            if (!self.start_date || self.start_date == null || self.start_date == "") {
                self.start_date_error_msg = "Start Date Required.";
                error = true;
            }

            if (self.amount == null || self.amount == 0 || !self.amount) {
                self.amount_error_msg = "Capital Amount is Required.";
                error = true;
            }

            if (self.rate == null || !self.rate || self.rate == 0) {
                self.rate_error_msg = "Depreciation Rate is Required.";
                error = true;
            }

            if (self.duration == '' || !self.duration || self.duration == 0) {
                self.duration_error_msg = "Duration is Required.";
                error = true;
            }

            if (self.vehicle_id == null || !self.vehicle_id.value) {
                self.vehicle_error_msg = "Asset is Required.";
                error = true;
            }

            if (self.schedule_type == null || self.schedule_type == '' || !self.schedule_type.value) {
                self.schedule_type_error_msg = "Schedule Type is Required.";
                error = true;
            }

             if (self.initial_residual == '' || !self.initial_residual || self.initial_residual == 0) {
                self.residual_error_msg = "Residual is Required.";
                error = true;
            }



            if (!error) {

                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                var typesArr = [];
                var amountArr = [];
                var taxPercentageArr = [];
                var totalChargeArr = [];

                if (segments[3]) {
                    $("#CreateDepriciationBtn").val("Updating ...");
                    $("#CreateDepriciationBtn").prop("disabled", true);
                    $("#CancelDepriciationBtn").prop("disabled", true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#CreateAndContinueDepriciationBtn").val("Saving ...");
                        $("#CreateDepriciationBtn").prop("disabled", true);
                        $("#CreateAndContinueDepriciationBtn").prop("disabled", true);
                        $("#CancelDepriciationBtn").prop("disabled", true);

                    } else {

                        $("#CreateDepriciationBtn").val("Saving ...");
                        $("#CreateDepriciationBtn").prop("disabled", true);
                        $("#CreateAndContinueDepriciationBtn").prop("disabled", true);
                        $("#CancelDepriciationBtn").prop("disabled", true);
                    }
                }

                var fields = $("#DepriciationForm").serializeArray();
                // alert(JSON.stringify(fields));


                if (self.vehicle_id == null) {
                    fields.push({
                        name: "vehicle_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "vehicle_id",
                        value: self.vehicle_id.value
                    });
                }

                if (self.schedule_type == null) {
                    fields.push({
                        name: "schedule_type_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "schedule_type_id",
                        value: self.schedule_type.value
                    });
                }
                fields.push({
                    name: "last_date",
                    value: self.last_date
                });
                fields.push({
                    name: "method",
                    value: self.method
                });
                fields.push({
                    name: "rate",
                    value: self.rate
                });

                fields.push({
                    name: "frequency",
                    value: self.frequency
                });
                fields.push({
                    name: "amount",
                    value: self.amount
                });

                // fields.push({
                //     name: "payment_no",
                //     value: self.payment_no
                // });
                fields.push({
                    name: "id",
                    value: segments[3]
                });

                // console.log(fields);
                $.ajax({
                    url: process.env.ROOT_API + "/depriciation-schedule/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;

                        if (segments[3]) {
                            $("#CreateDepriciationBtn").val("Update");
                            $("#CreateDepriciationBtn").prop("disabled", false);
                            $("#CancelDepriciationBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#CreateAndContinueDepriciationBtn").val("Save and Continue");
                                $("#CreateDepriciationBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationBtn").prop("disabled", false);
                                $("#CancelDepriciationBtn").prop("disabled", false);

                            } else {

                                $("#CreateDepriciationBtn").val("Save");
                                $("#CreateDepriciationBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationBtn").prop("disabled", false);
                                $("#CancelDepriciationBtn").prop("disabled", false);

                            }
                        }

                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                            return;
                        }
                        if (data.status == "success") {

                            if (flag == "Save and Continue") {

                                $("#DepriciationForm").trigger("reset");

                                self.start_date = "";
                                self.vehicle_id = '';
                                self.customer = '';
                                self.amount = "";
                                self.make = "";
                                self.model = "";
                                self.year = "";
                                self.schedule_type = null;
                                self.method = "",
                                self.residual = '',
                                self.initial_residual = '',
                                self.rate = "",
                                self.duration = '';
                                self.payment_no = '';
                                self.frequency = '';
                                self.last_date = '';

                            } else {
                                if (data.content.id != undefined){
                                    self.$router.push("/asset-depreciation/list/"+data.content.id);
                                }else{
                                    self.$router.push("/depreciation-schedule/list");
                                }
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3]) {
                            $("#CreateDepriciationBtn").val("Update");
                            $("#CreateDepriciationBtn").prop("disabled", false);
                            $("#CancelDepriciationBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#PurchaseOrderForm").trigger("reset");
                                $("#CreateAndContinueDepriciationBtn").val("Save and Continue");
                                $("#CreateDepriciationBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationBtn").prop("disabled", false);
                                $("#CancelDepriciationBtn").prop("disabled", false);

                            } else {

                                $("#CreateDepriciationBtn").val("Save");
                                $("#CreateDepriciationBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationBtn").prop("disabled", false);
                                $("#CancelDepriciationBtn").prop("disabled", false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-create')

                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },

        loadDepriciation() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/depriciation-schedule/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);

                        if (data.status == "success") {
                            var dataSet = data.content.result;
                            self.vehicle_id = {text:dataSet.unit_no,value:dataSet.vehicle_id};
                            self.schedule_type = {text:dataSet.schedule_type+' | '+dataSet.schedule_description,value:dataSet.schedule_type_id};
                            // setTimeout(function(){

                            //     if ((self.amount == '' || self.amount == null || self.amount == 0) && dataSet.original_cost > 0){
                            //         self.amount = dataSet.original_cost;
                            //     }
                            // self.calculateDeprate();

                            // },2000);
                            self.amount = dataSet.capital_amount;
                            setTimeout(function(){
                                self.calculateDeprate();
                            },2000);
                            self.rate = dataSet.depriciation_rate;
                            self.method = dataSet.method;
                            self.residual = dataSet.residual;
                            self.initial_residual = dataSet.initial_residual;
                            self.start_date = dataSet.start_date;
                            self.duration = dataSet.duration;
                            // self.payment_no = dataSet.no_of_payment;
                            self.frequency = dataSet.frequency;
                            self.last_date = dataSet.last_date;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                    }
                });
            },

        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        isNumberCheck: function (evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        backToList: function(){
            var self = this;


                self.$router.push('/depreciation-schedule/list');


        },
        addMonths(date, months) {
            var d = date.getDate();
            date.setMonth(date.getMonth() + +months);
            if (date.getDate() != d) {
            date.setDate(0);
            }
            return ("0"+(date.getMonth()+1)).slice(-2) +"/"+("0" + date.getDate()).slice(-2) + "/"+date.getFullYear();
        },
        calculateDeprate:function(){
          var self = this;
          var amt = self.removeFormat(self.amount);
          var res = self.removeFormat(self.initial_residual);
          if (amt > 0 && amt != '' && res != '' && res > 0 && self.duration != '' && self.duration > 0){
              var dep = (amt - res) / self.duration;
              self.dep_amount = dep.toFixed(2);
              var amt = (self.dep_amount / amt) * 100;

              self.rate = amt.toFixed(2);
          }
        },
        getLastDateofmonth:function(){
            var self = this;

            var date = new Date();
            var newdate = new Date();
            var arr = [];
            for(var i = 2; i > 0;i--){
                arr.push(moment(date).subtract(i, 'months').format('MM/DD/YYYY'));
            }
            for(var j = 0; j <= 3;j++){
                arr.push(moment(newdate).add(j, 'months').format('MM/DD/YYYY'));
            }
            self.dateArr = arr;
            console.log(self.dateArr);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/asset/DepriciationCreate.vue